import type { CLESSON_MODES } from '@yandex-int/k-common/constants';
import { put, select } from 'redux-saga/effects';

import { actions as lessonActions } from 'common.components/lesson';
import * as lessonAssignmentActions from 'common.components/lesson-view.assignment/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';

export function* setLessonModeSaga(action: ReturnType<typeof lessonAssignmentActions.setLessonMode>) {
    const lessonMode = action.lessonMode;

    try {
        const isDraft: boolean = yield select(lessonSelectors.getIsDraft);
        const savedLessonMode: CLESSON_MODES | null = yield select(lessonSelectors.getLessonMode);

        if (isDraft && lessonMode && lessonMode !== savedLessonMode) {
            yield put(lessonActions.setLessonMode({ mode: lessonMode }));
            yield put(lessonActions.saveLesson());
        }
    } catch (error) {
        console.error(error);
    }
}
